module.exports = __webpack_public_path__ + "components/TrapezoidMenu/layers.png?d9e91849";


//////////////////
// WEBPACK FOOTER
// ./components/TrapezoidMenu/layers.png
// module id = 2442
// module chunks = 0